const LOGO_SRC = "/wizardx-logo.png";

const Logo = ({ size = "md", showText = true, className = "", testId = "wizardx-logo" }) => {
  const sizes = {
    sm: { icon: "h-8 w-8", text: "text-sm" },
    md: { icon: "h-10 w-10", text: "text-lg" },
    lg: { icon: "h-14 w-14", text: "text-2xl" },
    xl: { icon: "h-20 w-20", text: "text-3xl" },
  };
  const selectedSize = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={testId}>
      <img
        src={LOGO_SRC}
        alt="Wizard X route glyph"
        className={`${selectedSize.icon} shrink-0 object-contain drop-shadow-[0_0_10px_rgba(6,182,212,0.28)]`}
        data-testid={`${testId}-image`}
      />
      {showText && (
        <div className="flex min-w-0 flex-col leading-tight">
          <span className={`truncate font-orbitron font-bold text-white ${selectedSize.text}`}>WIZARD X</span>
          {(size === "lg" || size === "xl") && (
            <span className="mt-1 text-[10px] font-medium uppercase text-cyan-400/70">Secure Access Portal</span>
          )}
        </div>
      )}
    </div>
  );
};

export const LogoIcon = ({ className = "h-8 w-8", testId = "wizardx-logo-icon" }) => (
  <img
    src={LOGO_SRC}
    alt="Wizard X"
    className={`${className} shrink-0 object-contain drop-shadow-[0_0_8px_rgba(6,182,212,0.24)]`}
    data-testid={testId}
  />
);

export default Logo;